import React from 'react';
import axios from 'axios';
import Request from '../../utils/request';
import PropTypes from 'prop-types';
import utils from '../../utils/utils';
import './style.less';

const CookieUtil = {
  getRaw: (key, str) => {
    if (CookieUtil._isValidKey(key)) {
      var reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)'),
        cookie = str || document.cookie,
        result = reg.exec(cookie);

      if (result) {
        return result[2] || '';
      }
    }
    return '';
  },
  _isValidKey: (key) => {
    return new RegExp(
      '^[^\\x00-\\x20\\x7f\\(\\)<>@,;:\\\\\\"\\[\\]\\?=\\{\\}\\/\\u0080-\\uffff]+$'
    ).test(key);
  },
};

const formulaFuncs = [
  {
    label: 'ROUNDDOWN() 向下舍入到指定位数',
    value: 'ROUNDDOWN(, 1)'
  },
  {
    label: 'ROUNDUP() 向上舍入到指定位数',
    value: 'ROUNDUP(, 1)'
  },
  {
    label: 'CALC() 混合运算',
    value: 'CALC()'
  }
]

const textFormulaFuncs = [
  {
    label: 'CONCATENATE(文本1, 文本2, ...) 将多个文本串联',
    value: 'CONCATENATE()'
  }
]

class PipelineCommunityCustom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      result: [],
      showFields: [],
      additiveVal: 0
    };
    this.openApiUrl = '';
  }

  async componentDidMount() {
    const { openApiUrl = '' } = this.props.config.associateConfig;
    const uid = await this.getUid();
    if (openApiUrl && uid) {
      this.getDmpData(openApiUrl, uid); 
    } else {
      this.handleFilterQuoteField();
    }
  }

  getDmpData = (openApiUrl, uid) => {
    const { filterConditions = [] } = this.props.config.associateConfig;
    const app_version = utils.getVersion();
    const isAndroid = utils.isAndroid();
    const $and = [], filter = {};
    if (filterConditions.length > 0) {
      const filterType = filterConditions[0].filterType;
      if (filterType === 'number') {
        uid = Number(uid)
      }
    }
    filter[filterConditions[0].filterValue] = {
      $eq: uid
    };
    $and.push(filter);

    if (!isAndroid || (isAndroid && utils.SHDiffVersion(app_version, '7.70.0'))) {
      Request({
        url: openApiUrl,
        method: 'post',
        withCredentials: true,
        data: {
          option: {
            filters: {
              $and: $and
            },
            orders: []
          }
        },
      }).then((res) => {
        const { status, data = {} } = res.data;
        if (status === 0 && data.list && data.list.length > 0) {
          const result = data.list[0];
          this.handleFilterQuoteField(result, uid);
        } else {
          this.handleFilterQuoteField();
        }
      });
    } else {
      axios({
        url: openApiUrl,
        method: 'post',
        withCredentials: true,
        data: {
          option: {
            filters: {
              $and: $and
            },
            orders: []
          }
        },
      }).then((res) => {
        const { status, data = {} } = res.data;
        if (status === 0 && data.list && data.list.length > 0) {
          const result = data.list[0];
          this.handleFilterQuoteField(result, uid);
        } else {
          this.handleFilterQuoteField();
        }
      });
    }
  };

  // 筛选引用字段
  handleFilterQuoteField = (result = {}, uid = '') => {
    const showFields = [];
    const { baseConfig = {}, fieldsNameList = [], formula = {} } = this.props.config;
    let { quoteFields = '' } = this.props.config.associateConfig;
    let additiveVal = 0;
    quoteFields = quoteFields.split(',');

    fieldsNameList.forEach(field => {
      const fieldKey = field.originalName
      const fieldValue = field.componentType !== 'formula' 
        ? result[fieldKey]
        : this.calculateFormula(field.content || [], result);
      const temp = {
        key: fieldKey,
        value: fieldValue,
        componentType: field.componentType,
        showRmbSymbol: field.showRmbSymbol
      };
      showFields.push(temp);
    })

    // 使用自定义字段名称
    showFields.forEach(field => {
      const key = field.key;
      const match = fieldsNameList.find(item => item.originalName === key);
      if (match && match.changeName) {
        field['key'] = match.changeName;
      }
    });

    if (uid) {
      if (formula.content.length > 0) {
        // 计算加和值
        const { content = [] } = this.props.config.formula;
        additiveVal = this.calculateFormula(content, result);
      } else {
        if (baseConfig.formula) {
          additiveVal = result[baseConfig.formula] || 0
        }
      }
    }

    this.setState({
      result,
      showFields,
      additiveVal: additiveVal
    });
  }

  calculateFormula = (content = [], result = {}) => {
    let formula = '', calculateResult = 0;
    
    const funcs = [...formulaFuncs, ...textFormulaFuncs]
    let nearestFunc = ''
    content.forEach((item) => {
      if (item.type == 'placeholder-text') {
        if (nearestFunc.startsWith('CONCATENATE')) {
          const val = result[item.value]
          formula += typeof val == 'number' ? val : `"${val || ''}"`;
        } else {
          const numberValue = +(result[item.value] || '');
          formula += `${isNaN(numberValue) ? 0 : numberValue}`;          
        }
      } else if (item.type == 'text') {
        formula += item.value;
        const func = funcs.find(func => `${item.value}`.endsWith(`${func.value.split('(')[0]}(`))
        if (func) {
          nearestFunc = func.value
        }
      }
    });
    try {
      // 这里定义的方法提供给eval的内部使用，请不要删除
      var ROUNDDOWN = (value, n) => {
        return eval(value).toFixed(n);
      };
      var ROUNDUP = (value, n) => {
        const ratio = Math.pow(10, n);
        return Math.ceil(eval(value) * ratio) / ratio;
      };
      var CONCATENATE = (...values) => {
        let result = ''
        values.forEach(o => {
          if (typeof o == 'string' && !funcs.some(func => o.indexOf(func.value.split('(')[0]) !== -1)) {
            result += o
          } else {
            result += eval(o)
          }
        })
        return result;
      };
      var CALC = (...values) => {
        let result = ''
        values.forEach(o => {
          result += eval(o)
        })
        return result;
      };
      calculateResult = eval(formula);
    } catch (error) {}
    if (typeof calculateResult != 'string') {
      calculateResult = ''
    }

    return calculateResult ? parseFloat(calculateResult).toString() : calculateResult;
  }

  getUid = () => {
    return new Promise((resolve, reject) => {
      if (utils.isShihuo()) {
        window.Jockey.send(
          'fetchCookies',
          {
            url: 'https://www.shihuo.cn',
          },
          (res) => {
            if (res.status == 0 && res.data && res.data.str) {
              utils.uploadTrack(this.props, {}, {
                bizExtra: {
                  cookie: res.data.str
                }
              });
              const cookieStr = res.data.str.split(';').join('; ');
              const u = decodeURIComponent(CookieUtil.getRaw('u', cookieStr));
              const uid = u ? u.split('|')[0] : '';
              resolve(uid);
            }
          }
        ); 
      } else {
        resolve(this.props.config.baseConfig.authorId);
      }
    })
  };

  render() {
    const { baseConfig = {} } = this.props.config;
    const { showFields = [], additiveVal } = this.state;
    return (
      <div
        className="pipeline-communityCustom"
        {...this.props['customAttributes']}
        style={{
          marginTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
        }}
      >
        {
          baseConfig.additiveTxt && (
            <div className="data-desc">
              <div className='desc-additive'>
                <div className="desc-label">{baseConfig.additiveTxt.slice(0, 12)}</div>
              </div>
              <p className="desc-value">
                {baseConfig.showRmbSymbol !== false && <span>¥</span>}{additiveVal}
              </p>
            </div>
          )
        }
        <div className="data-fields">
          <ul>
            {
              showFields.map((item, index) => {
                return (
                  <li key={`field-${index}`}>
                    <p className="fields-value">
                      { 
                        item.showRmbSymbol && <span>¥</span>
                      }
                      {
                        (item.value && item.value > 9999) 
                          ? parseFloat((item.value / 10000).toFixed(1)) + 'w' 
                          : (
                            (item.value && item.value.toString().indexOf('\N')) >= 0
                              ? 0
                              : item.value || 0
                          ) 
                      }
                    </p>
                    <p className="fields-label">{item.key.slice(0, 10)}</p>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

PipelineCommunityCustom.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCommunityCustom };
export default PipelineCommunityCustom;



// WEBPACK FOOTER //
// ./components/pipeline-communityCustom/index.js